<template>
    <div>
        <!-- Dialogo vinculado con acciones del dashboard-->
        <v-dialog @click.outside="volver" v-model="isActive" :width="width" persistent
            transition="dialog-bottom-transition" scrollable>
            <v-card class="rounded-0 ">
                <v-card class="rounded-0" height="50" flat>
                    <v-app-bar flat color="white" height="50">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-if="e1 !== 0" v-bind="attrs" v-on="on" icon @click.outside="volver"
                                    @keydown.esc="volver">
                                    <v-icon>mdi-arrow-left</v-icon>
                                </v-btn>
                                <v-btn v-else v-bind="attrs" v-on="on" icon @click.outside="cerrarDialogo"
                                    @keydown.esc="cerrarDialogo">
                                    <v-icon>{{ icon }}</v-icon>
                                </v-btn>
                            </template>
                            <span v-if="e1 == 0">Cerrar</span>
                            <span v-else>Atras</span>
                        </v-tooltip>
                        <v-toolbar-title class="text-h6 font-weight-bold primary--text"
                            style="white-space: normal; word-break: break-word;">{{
                            titulo }}</v-toolbar-title>
                    </v-app-bar>
                </v-card>
                <v-card class="mx-4 my-0 pa-0 elevation-0" v-if="!(tipo == 'fotoperfil')">
                    <v-alert class="rounded-0 font-weight-regular text-body-1 pa-2" dense dark color="orange darken-2"
                        icon="mdi-information" elevation="0">
                        Tomar la foto de frente en un fondo claro, sin sombras ni reflejos sobre el rostro o el
                        fondo
                    </v-alert>
                </v-card>
                <div v-if="!isAuthenticated" class="ma-0 pa-0">
                    <FormEditarFotoPre v-if="e1 == 0" @abrirCamera="goToCamera" @abrirPreview="goToImage"
                        @listoCerrar="cerrarDialogo" :tipo="this.tipo">
                    </FormEditarFotoPre>
                </div>
                <div v-else class="ma-0 pa-0">
                    <FormEditarFoto v-if="e1 == 0" @abrirCamera="goToCamera" @abrirPreview="goToImage"
                        @cerraDialogo="cerrarDialogo" :tipo="this.tipo">
                    </FormEditarFoto>
                </div>
                <!-- 
                        <CameraCanvas v-if="e1 == 1" @fotoCargada="cargaFoto" @fotoDescarta="descartar" :tipo="this.tipo">
                    -->
                <v-card-text v-if="e1 == 1">
                    <CameraCanvas @fotoCargada="cargaFoto" @fotoDescarta="descartar" :tipo="this.tipo">
                    </CameraCanvas>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

//Formularios
import FormEditarFoto from '@/components/forms/FormEditarFoto'
import FormEditarFotoPre from '@/components/forms/FormEditarFotoPre'
import CameraCanvas from '@/components/inputs/CameraCanvas'

import { mapActions, mapGetters } from 'vuex'

export default {
    props: ['titulo', 'tipo', 'width'],
    components: {
        //componentes

        //Formularios
        FormEditarFoto,
        FormEditarFotoPre,
        CameraCanvas,

    },
    data() {
        return {
            isActive: false,
            icon: 'mdi-close',
            e1: 0,

        }
    },
    computed: {

        ...mapGetters('dataUser', ['fototmp']),
        ...mapGetters('auth', ['user', 'isAuthenticated', 'emailAuth']),
        ...mapGetters('itemEdit', ['itemSelected']),
    },
    methods: {
        ...mapActions(['refreshData']),
        ...mapActions('itemEdit', ['vaciarItem']),
        ...mapActions('preafiliacion', ['addFotoCarnet']),
        ...mapActions('dataUser', ['precargaFoto', 'subirFotoPerfil']),


        cerrarDialogo() {
            // cierra el dialogo y elimina las variables almacenadas temporalmente
            // en el store
            // this.refreshData()
            //se vacia el store itemEdit
            if (this.itemSelected) {
                this.vaciarItem()
            }
            this.isActive = false
            if (this.isAuthenticated) {
                if (this.tipo == 'fotoperfil')
                    setTimeout(() => {
                        //  location.reload()
                    }, 500);
            }
        },
        abrirDialogo() {
            this.isActive = true
        },
        volver() {
            if (this.fototmp) {
                this.subirFotoPerfil({})
            }
            this.e1 = 0

        },
        goToCamera() {
            this.e1 = 1
        },
        goToImage() {
            this.e1 = 2
        },
        cargaFoto() {
            this.e1 = 0
            this.cerrarDialogo()
        },
        descartar() {
            this.e1 = 0
            console.log('foto descartada')
        },

    }

}

</script>
